export enum Range {
  Direct = "DIRECT",
  DirectLastYear = "DIRECTLASTYEAR",
  CurrentWeek = "CURRENTWEEK",
  CurrentWeekLastYear = "CURRENTWEEKLASTYEAR",
  CurrentMonth = "CURRENTMONTH",
  CurrentMonthLastYear = "CURRENTMONTHLASTYEAR",
  PreviousDay = "PREVIOUSDAY",
  PreviousDayLastYear = "PREVIOUSDAYLASTYEAR",
  LastWeek = "LASTWEEK",
  DirectLastWeek = "DIRECTLASTWEEK",
  LastWeekLastYear = "LASTWEEKLASTYEAR",
  LastMonth = "LASTMONTH",
  LastMonthLastYear = "LASTMONTHLASTYEAR",
  Today = "TODAY",
  NextDay = "NEXTDAY",
  Custom = "CUSTOM",
}

export function getLastYearRange(range: string): string | null {
  const pastRangeMap: Partial<Record<string, string>> = {
    [Range.Direct]: Range.DirectLastYear,
    [Range.CurrentWeek]: Range.CurrentWeekLastYear,
    [Range.CurrentMonth]: Range.CurrentMonthLastYear,
    [Range.PreviousDay]: Range.PreviousDayLastYear,
    [Range.LastWeek]: Range.LastWeekLastYear,
    [Range.LastMonth]: Range.LastMonthLastYear,
  };

  return pastRangeMap[range] || null;
}

type RangeOption = {
  label: string;
  value: string;
};

export const RANGE_OPTIONS: RangeOption[] = [
  { label: "Direct", value: "direct" },
  { label: "J-1", value: "j-1" },
  { label: "Sem. en cours", value: "week-current" },
  { label: "S-1", value: "s-1" }, // assuming typo "S-&" meant "S-1"
  { label: "Mois en cours", value: "month-current" },
  { label: "M-1", value: "m-1" },
];
